import { FC } from 'react';
import { SimplePageLayout } from 'src/components/layout/simple-page-layout';

export const LoadingPage: FC = () => (
  <SimplePageLayout>
    <p>Welcome to Prisma</p>
  </SimplePageLayout>
);
